// extracted by mini-css-extract-plugin
export default {"label":"_5F1jBoLMS-ZbPOdDqkDgo","destination":"_3aJsLVU86rHeLqTAS5Uzta","icon":"_2G6LU0dGX4u_RbG8IlR_xV","alert":"_2GuL53uY1qtmC38aWGCu0A"};